<template>
  <div>
    <!-- <Header title="" description="" /> -->
    <div class="seth-set bg-primary px-6 pt-12 pb-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon icon="ArrowLeftIcon" class="flex" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        Add-On Bundles
      </h2>
    </div>
    <div class="w-full flex bg-white height-100">
      <div class="flex w-full px-6 py-8 m fixed-top">
        <div class="relative w-8/12 pr-8">
          <MyAddons />

          <BuyAddons
            @setAddOns="set"
            @getCurrencySymbol="getCurrencySymbol"
            :dataGet="dataGet"
            @gstNumber="gstNumber"
            :addOnType="addOnType"
          />
        </div>
        <div class="w-4/12 pl-4">
          <!-- <Plans /> -->
          <Summary
            :selected="addOns"
            @selectedObject="selectedObject"
            :dataGet="dataGet"
            :currencySymbol="symbol"
            :gstNumberValue="gstNumberValue"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyAddons from "./components/MyAddons.vue";
import BuyAddons from "./components/BuyAddons.vue";
import Summary from "./components/Summary";
import Header from "@/views/adminPanel/layouts/components/Header";
// import Plans from "@/views/adminPanel/pages/ecommerce/components/Plans";
export default {
  components: {
    MyAddons,
    BuyAddons,
    Summary,
    Header,
  },
  data() {
    return {
      addOns: [],
      dataGet: false,
      symbol: "",
      gstNumberValue: 0,
      addOnType: "",
    };
  },

  methods: {
    set(val) {
      this.addOns = val;
    },
    getCurrencySymbol(val) {
      console.log(val, "AK Data");
      this.symbol = val;
    },
    gstNumber(val) {
      this.gstNumberValue = val;
    },
    selectedObject(value) {
      this.dataGet = value;
      console.log(this.dataGet, "Yooo");
    },
  },

  mounted() {
    this.addOnType = this.$route.params.type;
  },
};
</script>
